import React from 'react';
import classNames from 'classnames';
import Icon from 'components/Icon';

const Stepper = ({ step }) => {
  return (
    <div className="ld-contract-invoice-modal-stepper">
      <div
        className={classNames('ld-contract-invoice-modal-stepper-step', {
          passed: step > 1,
          active: step === 1,
        })}
      >
        <span className="mark-wrap">
          <span className="mark">
            <span className="point" />

            <Icon size={14} icon="booked" />
          </span>
        </span>
        <p>Terms Of Payment</p>
      </div>
      <div
        className={classNames('ld-contract-invoice-modal-stepper-step', {
          passed: step > 2,
          active: step === 2,
        })}
      >
        <span className="mark-wrap">
          <span className="mark">
            <span className="point" />
            <Icon size={14} icon="booked" />
          </span>
        </span>
        <p>Acknowledge of Terms and Conditions</p>
      </div>
      <div
        className={classNames('ld-contract-invoice-modal-stepper-step', {
          passed: step > 3,
          active: step === 3,
        })}
      >
        <span className="mark-wrap">
          <span className="mark">
            <span className="point" />
            <Icon size={14} icon="booked" />
          </span>
        </span>
        <p>Carrier's Liability Options</p>
      </div>
      <div
        className={classNames('ld-contract-invoice-modal-stepper-step', {
          passed: step > 4,
          active: step === 4,
        })}
      >
        <span className="mark-wrap">
          <span className="mark">
            <span className="point" />
            <Icon size={14} icon="booked" />
          </span>
        </span>
        <p>Customer Signature</p>
      </div>
    </div>
  );
};

export default Stepper;
